import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.saadtak.com";

// Pages that should not be indexed by search engines
const NOINDEX_ROUTES = ["/blog-admin"];

/**
 * Automatically sets the canonical URL and meta robots tag
 * based on the current route. This ensures every page has
 * its own unique canonical, preventing Google from treating
 * SPA pages as duplicates of the homepage.
 */
const DynamicCanonical = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Build canonical URL (remove trailing slash except for root)
    const cleanPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const canonicalUrl = `${SITE_URL}${cleanPath}`;

    // Update or create canonical link
    let canonicalEl = document.querySelector(
      'link[rel="canonical"]'
    ) as HTMLLinkElement | null;
    if (!canonicalEl) {
      canonicalEl = document.createElement("link");
      canonicalEl.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute("href", canonicalUrl);

    // Update og:url meta tag
    let ogUrlEl = document.querySelector(
      'meta[property="og:url"]'
    ) as HTMLMetaElement | null;
    if (!ogUrlEl) {
      ogUrlEl = document.createElement("meta");
      ogUrlEl.setAttribute("property", "og:url");
      document.head.appendChild(ogUrlEl);
    }
    ogUrlEl.setAttribute("content", canonicalUrl);

    // Handle noindex for admin/private pages
    const isNoindex = NOINDEX_ROUTES.some((route) =>
      pathname.startsWith(route)
    );
    let robotsEl = document.querySelector(
      'meta[name="robots"]'
    ) as HTMLMetaElement | null;

    if (isNoindex) {
      if (!robotsEl) {
        robotsEl = document.createElement("meta");
        robotsEl.setAttribute("name", "robots");
        document.head.appendChild(robotsEl);
      }
      robotsEl.setAttribute("content", "noindex, nofollow");
    } else {
      // Remove noindex if present (ensure pages are indexable)
      if (robotsEl) {
        robotsEl.remove();
      }
    }
  }, [pathname]);

  return null;
};

export default DynamicCanonical;
